import { Form, Input, Row } from 'antd';
import classNames from 'classnames/bind';
import { checkKeyDownNumberInput } from '~/utils';
import styles from './FormPhone.module.scss';

const cx = classNames.bind(styles);

const PhoneFModal = ({ onFinishPhone, formPhone, errPhone }) => {
    return (
        <Form onFinish={onFinishPhone} form={formPhone}>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Enter your phone number
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    We will send a confirmation code (6 digits) to your phone number
                </Row>
            </Form.Item>
            {/* <Form.Item>
                <Row justify="center" className={cx('err')}>
                    {errPhone}
                </Row>
            </Form.Item> */}
            <Row justify="center" className={cx('err')}>
                {errPhone}
            </Row>
            <Form.Item
                name="phone"
                rules={[
                    { required: true, message: 'Please enter phone number' },
                    {
                        // pattern: new RegExp(/^[0-9\S]*$/),
                        pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                        message: 'Wrong phone number format',
                    },
                    { min: 10, message: 'Phone number must have 10 digits' },
                ]}
            >
                <Input
                    placeholder="Phone number"
                    className={cx('item_input')}
                    maxLength={10}
                    onKeyDown={checkKeyDownNumberInput}
                />
            </Form.Item>

            <Form.Item style={{ marginTop: '40px' }}>
                <button htmlType="submit" className={cx('btn_login')}>
                    Confirm
                </button>
            </Form.Item>
        </Form>
    );
};

export default PhoneFModal;
